import React from "react";
import PropTypes from "prop-types";
import "./index.less";

const CardList = props => {
  return (
    <div className="weax-iconblock-cardlist">
      {
        props.datas.map((item, index) => (
          <a key={index} className="weax-iconblock-cardlist-item" href={item.link}>
            <div className="weax-iconblock-cardlist-cover">
              <img src={item.img} alt=""/>
            </div>
            <div className="weax-iconblock-cardlist-body">
              <p className="weax-iconblock-cardlist-title">{item.title}</p>
              <p className="weax-iconblock-cardlist-descript">{item.descript}</p>
            </div>
          </a>
        ))
      }
    </div>
  );
};

CardList.defaultProps = {
  templete: 'temp1',
  datas: [
    {
      title: '印花T恤连衣裙',
      img: 'http://eseal-out.weaver.com.cn/plugin/wea_sign/qianzhang/assets/images/shop_01.jpg',
      descript: '追光的礼裙-ICICLE ATELIER SS19,邀请摄影师 Tom Ordoyno,以传统胶片摄影,呈现本季最为精美的礼裙。',
      link: 'https://www.baidu.com'
    },
    {
      title: '廓形衣袖连衣裙',
      img: 'http://eseal-out.weaver.com.cn/plugin/wea_sign/qianzhang/assets/images/shop_02.jpg',
      descript: '从坯样、打褶、熨烫到修剪,一件礼裙，是能工巧匠的作品，也是时间的作品。',
      link: 'https://www.baidu.com'
    },
    {
      title: '波浪印花裙',
      img: 'http://eseal-out.weaver.com.cn/plugin/wea_sign/qianzhang/assets/images/shop_03.jpg',
      descript: '精工礼裙，历经时间打磨,如雕塑般永恒，又如光影般瞬息万变。',
      link: 'https://www.baidu.com'
    }
  ]
};

CardList.propTypes = {
  templete: PropTypes.string,
  datas: PropTypes.array
};

export default CardList;
